@if (copyConfigFinalised$ | async) {
  <eco-job-status-placeholder
    title="Tenant Configuration Successfully Imported!"
    subtitle="Configuration for Tenant {{ (copyToTenant$ | async)?.Value }} was successfully imported.">
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="copyAnotherTenant()">Copy Config from another tenant</button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #copyConfigForm="ngForm" data-qa-id="copyconfig-import-only-form">
    <div class="row selectors-container">
      <div>
        <span class="title">Copy To:</span>
        <mat-select name="copyToTenant" placeholder="Select copy to tenant" class="mat-primary"
          [(ngModel)]="copyToTenantValue" (selectionChange)="changeCopyTo()">
          @for (tenant of getCopyToTenantOptions(); track tenant) {
            <mat-option [value]="tenant.Value">
              {{ tenant.Value }}
            </mat-option>
          }
        </mat-select>
      </div>
      <div class="environment">
        <span class="title">Environment:</span>
        {{ copyToEnvironment$ | async }}
      </div>
    </div>
    <div class="row">
      <div class="control-label">Import Id:</div>
      <mat-form-field class="import-id-container row-full-width">
        <mat-label>Import Id</mat-label>
        <input matInput name="importId" type="text" [(ngModel)]="importId">
        @if (importId) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="importId=''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
    <div class="row">
      <div class="control-label">Upload Asset:</div>
      <div class="upload-import-container row-full-width">
        <label class="upload-label" for="uploadAsset">Upload Asset</label>
        <div class="upload-input-row">
          <input id="uploadAsset" name="uploadAsset" type="file" (change)="onFileSelected($event)">
          <button mat-icon-button aria-label="Upload" (click)="uploadFile()" [disabled]="!selectedFile || isUploading || !isCopyConfigAvailable()">
            <mat-icon>cloud_upload</mat-icon>
          </button>
        </div>
        @if (isUploading) {
          <mat-progress-bar mode="determinate" [value]="uploadProgress || 0" style="margin-top:8px;"></mat-progress-bar>
        }
      </div>
    </div>
    <div class="row">
      <button mat-raised-button [disabled]="!isCopyConfigAvailable() || !isImportIdValid()" class="mat-accent"
        type="submit" (click)="copyConfigConfirm()">
        Copy Configuration Import Only
      </button>
    </div>
  </form>
}
